import karteClient from '../common/karte/user';

document.addEventListener('DOMContentLoaded', () => {
  const loggedOutFlag = document.getElementById('logged_out_flag') as HTMLInputElement;

  if (loggedOutFlag == null) {
    return;
  }

  const sendLoggedOutToKarte = () => {
    // ログアウトイベント
    karteClient.userLogoutEvent();
  }

  const initialize = () => {
    sendLoggedOutToKarte();
  }

  // 実行
  initialize();
});
